import { render, staticRenderFns } from "./animation.vue?vue&type=template&id=5c999ad1&scoped=true&"
import script from "./animation.vue?vue&type=script&lang=js&"
export * from "./animation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c999ad1",
  null
  
)

export default component.exports